/* eslint-disable no-magic-numbers */
import React from 'react'
import { FormattedMessage } from 'react-intl'
import { congregationOptions } from 'constants/congregationOptions'

export const makeCalculationsRowsCongregationCriteria = (congregationList) => {
  return congregationList.map((item) => {
    const speciesGroup = congregationOptions.find((element) => {
      return element.value === item.CongregationGroupId
    })

    return {
      speciesGroup: speciesGroup.label,
      estimateBest: item.best === null ? '-' : item.best,
      ibaCriteria: item.congregationCriterias.length > 0 ? item.congregationCriterias.join(', ') : '-'
    }
  })
}



import { useIBAAccess } from 'hooks/useIBAAccess'

export const makeCalculationsColumnsCongregationCriteria = () => {
  const { canSeeIBACriteria } = useIBAAccess()
  
  const baseColumns = [
    {
      id: 'speciesGroup',
      header: (
        <>
          <FormattedMessage id='speciesGroup' />
        </>
      ),
      accessorKey: 'speciesGroup',
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'estimateBest',
      header: (
        <>
          <FormattedMessage id='estimateBest' />
        </>
      ),
      accessorKey: 'estimateBest',
      cell: ({ getValue }) => getValue()
    },
  ]

  // Only add IBA criteria column if user has IBA access
  if (canSeeIBACriteria) {
    baseColumns.push({
      id: 'ibaCriteria',
      header: (
        <>
          <FormattedMessage id='ibaCriteria' />
        </>
      ),
      accessorKey: 'ibaCriteria',
      cell: ({ getValue }) => getValue()
    })
  }

  return baseColumns
}
